exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app .sidebar-container #el-menu-vertical-version.el-menu[data-v-33ec43fc] {\n  position: absolute;\n  bottom: 0px;\n  height: 50px;\n}\n#el-menu-vertical-version > .el-menu-item[data-v-33ec43fc] {\n  font-size: 10px;\n  line-height: 16px !important;\n}\n#el-menu-vertical-version span[data-v-33ec43fc] {\n  color: #666;\n}\n", ""]);

// exports
